import { apiClient } from './client.js';

export const fcmApi = {
  register:   (token) => apiClient.post('/fcm-tokens', { token }),
  unregister: (token) => apiClient.delete('/fcm-tokens', { data: { token } }),
};
